import InlineAlert from '../BaseComponents/Alert/InlineAlert'
import useConnectionStatus from '../../hooks/useConnectionStatus'

// Issue #759: mounted once, globally (see Router.tsx), so every page shows an explicit indicator
// instead of silently leaving stale tables/summaries looking live when the server is unreachable.
function ConnectionStatusBanner() {
	const isConnected = useConnectionStatus()

	if (isConnected) {
		return null
	}

	return (
		<InlineAlert type="warning" className="m-0 rounded-none justify-center" data-testid="connection-lost-banner">
			{/* Issue #759 (final review F7): useReconnectProbe.ts makes this true, but only while this
			    tab stays focused and only for a bounded number of attempts - avoid an unconditional
			    "we'll reconnect automatically" guarantee the app cannot actually keep. */}
			Connection lost. Information on screen may be out of date - we&apos;ll try to reconnect
			automatically while this tab stays open and in focus.
		</InlineAlert>
	)
}

export default ConnectionStatusBanner
